<template>
  <div id="app" style="height:100vh">
    <div>
      <!-- 加载动画 -->
      <div class="loads" v-show="isload">
        <dv-loading style="width: 250px; height: 250px">Loading...</dv-loading>
      </div>
      <div class="time">
        <div style="margin-top: 0px">
          <!-- <el-date-picker
            style="width: 5rem"
            size="mini"
            v-model="dateFilter"
            type="daterange"
            start-placeholder="开始"
            end-placeholder="结束"
            :picker-options="pickerOptions"
            @change="dateFilterWhere()"
          >
          </el-date-picker> -->
          <span>{{ now }} {{ week }}</span><br/>
          <span>更新时间：{{ updateTimeText }}</span>
        </div>
      </div>
      <div @click="signOut" class="power">
        <i style="cursor: pointer" class="el-icon-back"></i>
      </div>
      <div class="logoImg">
        <img style="height: 0.8rem" :src="logoSrc" />
      </div>
      <header class="w-100 flex j-center a-center">
        <dv-decoration-5
          :dur="10"
          style="position: absolute; bottom: 0; right: 0; height: 50%"
          class="w-100"
        />
        <div class="font-big font-weight">
          {{ kanban["title"] ? kanban["title"] : "升级流程看板" }}
        </div>
      </header>
    </div>
    <div class="p">
      <el-row :gutter="12">
        <template v-for="(item, i) in kanbanCard">
          <el-col
            v-if="item['id'] == 'deptCategory'"
            :key="i"
            :span="item['col']"
          >
            <deptCategory :headTitle="item.title" :typeBean="deptList" />
          </el-col>
          <el-col
            v-if="item['id'] == 'monthCategoryTotal'"
            :key="i"
            :span="item['col']"
          >
            <monthCategoryTotal :headTitle="item.title" :mttr="monthTotal" />
          </el-col>
          <el-col
            v-if="item['id'] == 'monthTotal'"
            :key="i"
            :span="item['col']"
          >
            <monthTotal :headTitle="item.title" :mttr="monthTotal"/>
          </el-col>
          <el-col
            v-if="item['id'] == 'monthDay'"
            :key="i"
            :span="item['col']"
          >
            <monthDayClose :headTitle="item.title" :mttr="monthDayList" />
          </el-col>
        </template>
      </el-row>
    </div>
    <audio></audio>
  </div>
</template> 

<script>
import API from "@/utils/api";
import router from "../../../router";
import format from "date-fns/format";
import deptCategory from "../component/dept-category.vue";
import monthCategoryTotal from "../component/month-category-total.vue";
import monthTotal from "../component/month-total.vue";
import monthDayClose from "../component/month-day-close.vue";

export default {
  name: "andon-board-app",
  components: {
    deptCategory,
    monthCategoryTotal,
    monthTotal,
    monthDayClose
  },
  data() {
    return {
      updateTimeText:null,
      kanbanSelf: false,
      isload: false,
      websock: null,
      kanban: {
        title: "升级流程看板",
      },
      kanbanCard: [{}],
      reconnectData: null,
      lockReconnect: false,
      deptList: [],
      monthDayList: [],
      monthTotal: [],
      product: {},
      now: null,
      week: null,
      weekHour: [],
      productLineHour: [],
      stationPlato: [],
      linePlatoList: [],
      mttr: [],
      mtbf: [],
      logoSrc: "/assets/img/logo_light.png",
      audioSrc: require("@/assets/mp3/alert.mp3"),
      deviceBean: {
        confirm: 0,
        pending: 0,
        process: 0,
        evaluate: 0,
        count: 0,
        power: 0,
        errorCount: 0,
      },
      dateFilter: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  mounted() {
    this.webSocket();
    this.loadData();
    //钟表
    setInterval(this.clock, 1000);
  },
  created() {
    this.isload = true;
    this.getDesign();
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  methods: {
    play() {
      var task = this.taskList;
      var now = new Date().getTime();
      for (var i = 0; i < task.length; i++) {
        var afterDate = now - task[i]["createdTime"];
        //两分钟内，定义为新异常
        if (task[i]["status"] == 0 && afterDate <= 1000 * 60 * 2) {
          var audios = new Audio(this.audioSrc);
          audios.controls = false;
          audios.play();
          setTimeout(() => {
            audios.play();
          }, 3000);
          break;
        }
      }
    },
    signOut() {
      router.back();
    },
    selectProduct(item) {
      this.product = item || {};
      this.isload = true;
      this.loadData();
    },
    dateFilterWhere() {
      this.isload = true;
      this.loadData();
    },
    getDesign() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        var kanbanSelf = null;
        if (kanbanSelf == null || kanbanSelf == "false") {
          // 未开启自定义看板
          var card = [
            { id: "deptCategory", col: 12, title: "部门统计" },
            { id: "monthCategoryTotal", col: 12, title: "PDCA-QRAP-LLC" },
            { id: "monthDay", col: 12, title: "关闭天数" },
            { id: "monthTotal", col: 12, title: "升级数量" },
          ];
          this.kanbanCard = card;
          return;
        }
      }
    },
    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        
        API.loadTheme().then((re) => {
          if (re.success && re["list"].length > 0) {
            this.logoSrc = re["list"][0]["icon"];
          }
        });

        API.getEscalation()
          .then((res) => {
            this.isload = false;
            if (res.success === true) {
              this.deptList = res["deptTotal"];
              this.monthDayList = res["monthDayClose"];
              this.monthTotal = res["monthCategoryTotal"];
              var now = new Date();
              this.updateTimeText = format(now, "MM-dd HH:mm:ss");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadProductLine() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadProductLine()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/escalation/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/escalation/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("安灯socket连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("安灯socket连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log("安灯socket断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      console.log(data);
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
  },
};
</script>
<style scoped>
#app {
  background: url("../../../assets/img/bg2.png");
}
.prductCategory {
  color: white;
  position: absolute;
  right: 25%;
  top: 20px;
  z-index: 999999;
}
.loads {
  background: #06164a;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

header {
  background: url("../../../assets/img/head_bg.png");
  background-size: 100% 100%;
  position: relative;
  height: 10vh;
}

/* 媒体查询  */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}

@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}

/* 主题色 */
.color-blue {
  color: #1fe9e8;
}
.color-gray {
  color: #cdeaf6;
}
.logoImg {
  position: absolute;
  left: 80px;
  top: 0px;
  font-size: 22px;
  z-index: 999;
}
.el-input__inner {
  background-color: black !important;
  border-radius: 0 !important;
}
</style>
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/escalation/board/board.vue